import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { teamKeyOf } from '../gameUtils';
import { statsGameApi } from '../statsGameApi';

// Starting-5 picker: auto-opens on a fresh active game, walks team A then B.
export function useLineupFlow({ gameId, game, loading, onCourt, recentEntries, fetchAll, onFreshStartersSet }) {
  const [pickingLineupFor, setPickingLineupFor] = useState(null);

  useEffect(() => {
    if (loading || !game || pickingLineupFor) return;
    if (game.status !== 'active') return;
    if (onCourt.a.length === 0 && onCourt.b.length === 0 && recentEntries.length === 0) {
      setPickingLineupFor('a');
    }
  }, [loading, game, onCourt, recentEntries, pickingLineupFor]);

  const confirmLineup = async (ids) => {
    if (ids.length !== 5) return;
    const team = pickingLineupFor;
    try {
      const res = await statsGameApi.lineup(gameId, team, ids);
      if (!res.ok) throw new Error();
      toast.success(`${game[teamKeyOf(team)].name} starters set`);
      if (team === 'a' && onCourt.b.length === 0) {
        setPickingLineupFor('b');
      } else {
        setPickingLineupFor(null);
        if (recentEntries.length === 0) onFreshStartersSet();
      }
      fetchAll();
    } catch { toast.error('Could not save lineup'); }
  };

  return { pickingLineupFor, setPickingLineupFor, confirmLineup };
}
